import {
  ITerminalUser,
  UserInvitationStatus,
} from 'src/app/features/settings/models/user.model';
import { IUserDetails } from '../models/user-details.model';

export const isUserDeactivated = (user: ITerminalUser | null): boolean =>
  !!user &&
  !user.is_approved &&
  deactivatedInvitationStatuses.includes(user.invitation_status_string);

const deactivatedInvitationStatuses = [
  UserInvitationStatus.NotCreated,
  UserInvitationStatus.Deactivated,
];

/**
 * convert form state to ITerminalUser
 */
export const convertFormToITerminalUser = (
  userDetails: IUserDetails,
  existingUser?: ITerminalUser | null,
): ITerminalUser => {
  const formParams = {
    first_name: userDetails.firstName,
    last_name: userDetails.lastName,
    name: `${userDetails.firstName} ${userDetails.lastName}`,
    email: userDetails.email,
    phone: userDetails.phone || null,
    primary_user_group: JSON.parse(userDetails.role),
    npn: userDetails.npn,
  };

  const baseUser = existingUser ?? defaultUser();

  return { ...baseUser, ...formParams };
};

const defaultUser = (): ITerminalUser => ({
  id: '',
  first_name: '',
  last_name: '',
  name: '',
  email: '',
  phone: null,
  invitation_status_string: UserInvitationStatus.Deactivated,
  is_approved: false,
  primary_user_group: { id: '', name: '' },
  user_group_memberships: [],
  npn: '',
});
